import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export const useRedirectIfLoggedInHook = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const uid = useSelector((state) => state.user.uid);
  const authInitializing = useSelector((state) => state.user.authInitializing);

  useEffect(() => {
    if (authInitializing) {
      return;
    }

    if (uid) {
      const redirectPath =
        new URLSearchParams(location.search).get("redirect") || "/dashboard";
      navigate(redirectPath);
    }
  }, [authInitializing, location.search, navigate, uid]);
};
